orders-planner-line-ui-uneditable
  .back-col
    orders-planner-line-back(tag-scope="orders_planner_line_back" data-line-id="{this.opts.id}")
  .dates-col
    orders-planner-line-ui-schedules-uneditable(tag-scope="{this.tagScope}")
  .forward-col
    orders-planner-line-forward(tag-scope="orders_planner_line_forward" data-line-id="{this.opts.id}")
  script(type="typescript").
    this.mixin('orders.planner.line');
